<template>
  <div>
    <AppTitle name="หน้าหลัก" />

    <WidgetCount />

    <div class="col-md-12">
      <div class="tile">
        <!-- Loading Overlay -->
        <LoadingOverlay v-if="isLoading" />

        <div class="tile-title-w-btn">
          <h3 class="title">Title</h3>
        </div>

        <div class="tile-body"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import AppTitle from "@/components/layouts/AppTitle.vue";
import WidgetCount from "@/components/WidgetCount.vue";
// import api from "@/api/http";
// import { showErrorAlert } from "@/utils/sweetAlert";

// const bookings = ref([]);

// Fetch bookings
// const fetchBookings = async () => {
//   isLoading.value = true;
//   try {
//     const response = await api.get("/bookings");
//     bookings.value = response.data;
//   } catch (error) {
//     console.error("Error fetching bookings:", error);
//     showErrorAlert("โหลดข้อมูลไม่สำเร็จ", "ไม่สามารถโหลดข้อมูลการจองได้");
//   } finally {
//     isLoading.value = false;
//   }
// };

onMounted(() => {
  // fetchWards();
  // fetchBookings();
  // fetchAdminWards();
});
</script>
